(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aq-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const validateMessage = message => {
      let error = '';
      if (!message.value.trim()) error = message.dataset.messageMissing;
      else if (message.value.length > message.maxLength) error = message.dataset.messageTooLong;
      message.setCustomValidity(error);
    };
    document.addEventListener('input', event => {
      if (event.target.matches('.aq-contact-form textarea[name="contact[body]"]')) validateMessage(event.target);
    });
    document.addEventListener('submit', event => {
      if (!event.target.matches('.aq-contact-form')) return;
      const message = event.target.querySelector('textarea[name="contact[body]"]');
      if (!message) return;
      validateMessage(message);
      if (!event.target.checkValidity()) {
        event.preventDefault();
        event.target.reportValidity();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aq-media-kit-hero"] && !Shopify.designMode) return;
  try {
    
  if (window.customElements && !customElements.get('aq-media-kit-video')) {
    customElements.define('aq-media-kit-video', class extends HTMLElement {
      constructor() {
        super();
        this.onPlay = this.play.bind(this);
      }

      connectedCallback() {
        this.playButton = this.querySelector('[data-aq-media-kit-play]');
        const template = this.querySelector('[data-aq-media-kit-template]');
        if (!this.playButton || !template || !template.content.querySelector('iframe[data-src]')) return;
        this.playButton.addEventListener('click', this.onPlay);
        this.playButton.hidden = false;
      }

      disconnectedCallback() {
        if (this.playButton) this.playButton.removeEventListener('click', this.onPlay);
      }

      play() {
        const template = this.querySelector('[data-aq-media-kit-template]');
        const sourceFrame = template && template.content.querySelector('iframe[data-src]');
        if (!sourceFrame) return;
        const source = sourceFrame.dataset.src;
        if (!source || !/^https:\/\/www\.youtube-nocookie\.com\/embed\/[A-Za-z0-9_-]+\?/.test(source)) return;
        const iframe = sourceFrame.cloneNode(true);
        iframe.src = source;
        iframe.removeAttribute('data-src');
        this.replaceChildren(iframe);
        iframe.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
